<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Personal Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <br />
        <v-row justify="center" align="center">
            <!-- {{sub_crt_list}} -->
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.employee_code"
                    name="employee_code" label="Employee Code" disabled></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.firstname" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_firstname" label="First name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.middlename" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_middlename" label="Middle name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.lastname" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_lastname" label="Last name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.fullname" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                @input="convertToUnicode(inst_data.fullname, 'unicode_name')"
                    name="inst_fullname" label="Full Name"></v-text-field>
            </v-col>
             <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.unicode_name"
                    name="inst_unicode_name" label="Unicode Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="gender_list" v-model="inst_data.gender" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    label="Gender" placeholder="Select Gender"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" sm="4" md="4">
                <b> Date of Joining </b>::
                <input type="date" id="datePickerId" v-model="inst_data.dateofjoining" />
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <b> Date of Birth </b>::
                <input type="date" id="datePickerId" v-model="inst_data.date_of_birth" />
            </v-col> -->
            <!-- {{emp_dob_doj}} -->
            <v-col cols="12" sm="4" md="4">
    <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :disabled="emp_dob_doj"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="inst_data.dateofjoining"
                dense
                rounded
                outlined
                hint="YYYY/MM/DD format"
                persistent-hint
                label="Date Of Joining"
                prepend-icon="mdi-calendar"
                :readonly="emp_dob_doj"
                :filled="emp_dob_doj"
                v-bind="attrs"
                v-on="emp_dob_doj ? {} : on"
                @change="getDob()"
            />
        </template>

        <v-date-picker
            v-if="!emp_dob_doj"
            v-model="inst_data.dateofjoining"
            @input="menu2 = false"
        />
    </v-menu>
</v-col>
            <v-col cols="12" sm="4" md="4">
    <v-menu
        v-model="menu3"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :disabled="emp_dob_doj"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="inst_data.date_of_birth"
                dense
                rounded
                outlined
                hint="YYYY/MM/DD format"
                persistent-hint
                label="Date Of Birth"
                prepend-icon="mdi-calendar"
                :readonly="emp_dob_doj"
                :filled="emp_dob_doj"
                v-bind="attrs"
                v-on="emp_dob_doj ? {} : on"
            />
        </template>

        <v-date-picker
            v-if="!emp_dob_doj"
            v-model="inst_data.date_of_birth"
            @input="menu3 = false"
        />
    </v-menu>
</v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.birth_place"
                    name="inst_birth_place" label="Birth Place"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="country_list"
                    v-model="inst_data.birthcountry" label="Birth Country"
                    placeholder="Select Country"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.date_of_birth_in_words"
                    name="inst_date_of_birth_in_words" label="Date of Birth in Words"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.birth_address"
                    name="inst_birth_address" label="Birth Address"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="marital_status_list" item-text="name"
                    item-value="id" v-model="inst_data.marital_status" label="Marital Status"
                    placeholder="Select Marital Status " />
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="designation_list"
                    v-model="inst_data.designation" label="Designation" placeholder="Select Designation"
                    :readonly="emp_dob_doj"
                    :filled="emp_dob_doj"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="employee_type_list" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    v-model="inst_data.employeetype" label="Employee Type"
                    placeholder="Select Employee Type"></v-autocomplete>
            </v-col>
             <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="service_type_list" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    v-model="inst_data.service_type" label="Employee Category"
                    placeholder="Select Employee Category"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0" v-if="org_id == 'sbpps' || org_id == 'wws' || org_id == 'desschool' && department_list != ''">
                <v-autocomplete dense rounded color="#0F2027" outlined
                    :items="department_list" v-model="inst_data.department" label="Department" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    placeholder="Select Department"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense color="#0F2027" rounded :items="blood_group_list" outlined
                    v-model="inst_data.bloodgroup" label="Blood Group"
                    placeholder="Select Blood Group"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.aadhar_no" name="aadhar_no"
                    label="Aadhaar No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete v-if="payment_section_list != ''" dense rounded color="#0F2027" outlined
                    :items="payment_section_list" item-text="name" item-value="id" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    v-model="inst_data.employeepaymentsection" label="Section" placeholder="Select Section " />
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="language_list"
                    v-model="inst_data.mothertoungue" label="Mother Tounge"
                    placeholder="Select Language"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field outlined color="#0F2027" flat dense v-model="inst_data.highest_academic_qualification" rounded
                    name="highest_academic_qualification" label="Highest Academic Qualification"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field outlined color="#0F2027" flat dense v-model="inst_data.highest_academic_qualification_spl" rounded
                    name="highest_academic_qualification_spl"
                    label="Highest Academic Qualification Specialisation"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field outlined color="#0F2027" flat dense v-model="inst_data.highest_professional_qualification" rounded
                    name="highest_professional_qualification" label="Highest Professional Qualification"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field outlined color="#0F2027" flat dense
                    v-model="inst_data.highest_professional_qualification_spl" name="highest_professional_qualification" rounded
                    label="Highest Professional Qualification Specialisation"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                    v-model="inst_data.total_teaching_experience" name="total_teaching_experience"
                    label="Total Teaching Experience"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                    v-model="inst_data.teaching_experience_in_current_school"
                    name="teaching_experience_in_current_school"
                    label="Teaching Experience In Current School"></v-text-field>
            </v-col>
            <v-col v-if="sub_crt_list.length > 0" cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded multiple color="#0F2027" outlined :items="sub_crt_list"
                    v-model="inst_data.sub_crt_stud_taughts" label="Subject Certification (students taught)"
                    placeholder="Subject Certification (students taught)"></v-autocomplete>
            </v-col>
            <v-col v-if="main_sub_list.length > 0" cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined multiple :items="main_sub_list"
                    v-model="inst_data.main_sub_taughts" label="Main Subject Taught"
                    placeholder="Main Subject Taught"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <!-- <v-autocomplete dense rounded multiple color="#0F2027" outlined :items="add_sub_list" v-model="inst_data.additional_sub_taughts" label="Additional Subject Taught" placeholder="Additional Subject Taught"></v-autocomplete> -->
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.additional_sub_taughts"
                    name="additional_sub_taughts" label="Additional Subject Taught"
                    placeholder="Additional Subject Taught"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-text-field rounded multiple outlined color="#0F2027" flat dense v-model="inst_data.spouse_name"
                    name="spouse_name" label="Spouse Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" item-text="education" outlined :items="education_list"
                    v-model="inst_data.maths_science_studied_up_to" label="Maths & Science studied up to"
                    placeholder="Select Maths & Science studied up to"></v-autocomplete>
                <v-text-field v-if="inst_data.maths_science_studied_up_to == 'Any other'" rounded outlined
                    color="#0F2027" flat dense v-model="inst_data.maths_science_studied_up_to_any_other"
                    name="maths_science_studied_up_to_any_other" label="Maths & Science studied up to"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" item-text="education" outlined :items="education_list"
                    v-model="inst_data.social_science_studied_up_to" label="Social Science studied up to"
                    placeholder="Select Social Science studied up to"></v-autocomplete>
                <v-text-field v-if="inst_data.social_science_studied_up_to == 'Any other'" rounded outlined
                    color="#0F2027" flat dense v-model="inst_data.social_science_studied_up_to_any_other"
                    name="social_science_studied_up_to_any_other" label="Social Science studied up to"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" item-text="education" outlined :items="education_list"
                    v-model="inst_data.english_studied_up_to" label="English studied up to"
                    placeholder="Select English studied up to"></v-autocomplete>
                <v-text-field v-if="inst_data.english_studied_up_to == 'Any other'" rounded outlined color="#0F2027"
                    flat dense v-model="inst_data.english_studied_up_to_any_other"
                    name="english_studied_up_to_any_other" label="English studied up to"></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete
                    v-if="payment_section_list!=''"
                    dense
                    rounded
                    color="#0F2027"
                    outlined
                    :items="payment_section_list"
                    item-text="name"
                    item-value="id"
                    v-model="inst_data.employeepaymentsection"
                    label="Section"
                    placeholder="Select Section "
                />
            </v-col> -->
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete v-if="shift_list != ''" dense rounded color="#0F2027" outlined :items="shift_list"
                    item-text="name" item-value="id" v-model="inst_data.employeeshift" label="Employee Shift"
                    placeholder="Select Employee Shift " />
            </v-col>
            <!-- dropdown for setting the Biometric value as yes or no (ByAtharwa)-->
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete
                    dense rounded outlined color="#0F2027" :items="biometric_flag_list" item-text="text" item-value="value"
                    v-model="inst_data.do_not_consider_for_biometric" label="Exclude from Biometric"
                    placeholder="Select Option"
                />
            </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
            <v-text-field
                rounded
                outlined
                color="#0F2027"
                flat
                dense
                v-model="inst_data.emp_national_code"
                name="inst_national_code"
                label="National Code"
                maxlength="10"
                counter="10"
                :rules="[
                    v => !v || /^[A-Za-z]{2}[0-9]{8}$/.test(v) || 'Enter 2 letters followed by 8 digits'
                ]"
            ></v-text-field>
        </v-col>
        </v-row>
        <v-toolbar v-if="org_id == 'sbpps'" flat dense class="toolbar">
            <v-toolbar-title>Account Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <br v-if="org_id == 'sbpps'">
        <v-row v-if="org_id == 'sbpps'">
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.oasis_id" type="number"  :readonly="emp_account_lock" :filled="emp_account_lock"
                    name="oasis_id" label="Oasis Id"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.aadhar_no" type="number"  :readonly="emp_account_lock" :filled="emp_account_lock"
                    name="inst_aadhar_no" label="Aadhaar No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.pan_no" name="inst_pan_no"  :readonly="emp_account_lock" :filled="emp_account_lock"
                    label="Pan No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.pf_no" name="inst_pan_no"  :readonly="emp_account_lock" :filled="emp_account_lock"
                    label="PF No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.uan_no" name="inst_uan_no" :readonly="emp_account_lock" :filled="emp_account_lock" 
                    label="UAN No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                <v-autocomplete dense rounded color="#0F2027" outlined :items="bank_list" v-model="inst_data.bank" :readonly="emp_account_lock" :filled="emp_account_lock" 
                    label="Bank" placeholder="Select Bank"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.bank_account_no" :readonly="emp_account_lock" :filled="emp_account_lock"
                    name="inst_pan_no" label="Bank Account No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.bank_ifsc_code" :readonly="emp_account_lock" :filled="emp_account_lock"
                    name="inst_pan_no" label="IFSC Code"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.bank_branch_name" :readonly="emp_account_lock" :filled="emp_account_lock" 
                    name="inst_pan_no" label="Branch"></v-text-field>
            </v-col>
        </v-row>

        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Contact and Address Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <br />
        <v-row>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.official_email_id" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_pan_no" label="Official Email Id"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.personal_email" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_pan_no" label="Personal Email Id"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined type="number" color="#0F2027" flat dense v-model="inst_data.mobile_no" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_pan_no" label="Contact No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_data.emergency_contact_name" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    name="inst_pan_no" label="Emergancy Contact Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-text-field rounded outlined type="number" color="#0F2027" flat dense :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    v-model="inst_data.emergency_contact_number" name="inst_pan_no"
                    label="Emergancy Contact No"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0"></v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-textarea rows="3" clearable color="#0F2027" counter auto-grow v-model="inst_data.local_address" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    label="Local Address" outlined></v-textarea>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-checkbox label="Is Permenant Add. is same as Local Add." color="#0F2027" hide-details
                    v-model="copy_data" @click="copyAddress()"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                <v-textarea rows="3" clearable auto-grow color="#0F2027" counter v-model="inst_data.permanent_address" :readonly="emp_contact_address_lock" :filled="emp_contact_address_lock"
                    label="Permenant Address" outlined></v-textarea>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-btn class="button" small @click="saveData()">Save</v-btn>
        </v-row>
        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please wait..
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import moment from "moment";
export default {
    props: {
        instid: Number,
    },
    data() {
        return {
            org_id: null,
            marital_status_list: [],
            payment_section_list: [],
            shift_list: [],
            add_sub_list: [],
            sub_crt_list: [],
            main_sub_list: [],
            menu: false,
            employee_details_can_not_edit: false,
            modal: false,
            modal2: false,
            modal3: false,
            menu2: false,
            menu3: false,
            menu11: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            copy_data: false,
            dialog_upload: false,
            inst_data: "",
            gender_list: [],
            country_list: [],
            blood_group_list: [],
            bank_list: [],
            designation_list: [],
            employee_type_list: [],
            department_list: [],
            language_list: [],
            service_type_list : [],
            education_list: [
                { id: 1, education: "Grade 10" },
                { id: 2, education: "Grade 12" },
                { id: 3, education: "Graduation" },
                { id: 4, education: "Post Graduation" },
                { id: 5, education: "Any other" },
            ],
            emp_dob_doj: null,
            emp_contact_address_lock: null,
            emp_account_lock: null,
            biometric_flag_list: [                  // list for biometric dropdown (By Atharwa)
                { text: "No", value: false },
                { text: "Yes", value: true },
            ],
        };
    },
    watch: {
        instid() {
            this.getData();
        },
    },
    mounted() {
        this.getData();
        this.org_id = localStorage.getItem("EPS-tenant");
    },
    methods: {
        async convertToUnicode(text, targetField) {
            if (!targetField) return

            let value = text || ''

            if (!value) {
                this.inst_data[targetField] = ''
                return
            }

            const res = await fetch(
                "https://inputtools.google.com/request?text=" +
                encodeURIComponent(value) +
                "&itc=mr-t-i0-und&num=1"
            )

            const data = await res.json()

            if (data[0] === "SUCCESS") {
                this.inst_data[targetField] = data[1][0][1][0]
            }
        },
        getData() {

            this.instructor_id = this.instid;
            const formData = {
                instid: this.instid,
            };
            axios
                .post("/EmployeeProfile/getEmployeePersonal", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.inst_data = res.data.inst_data;
                        if (this.inst_data.do_not_consider_for_biometric === undefined || this.inst_data.do_not_consider_for_biometric === null) {
                        this.inst_data.do_not_consider_for_biometric = false;
                        }
                        let formatDate = moment(this.inst_data.date_of_birth).format("MMMM Do YYYY");
                        // alert(formatDate)
                        this.inst_data.date_of_birth_in_words = formatDate;
                        this.gender_list = res.data.gender_list;
                        this.country_list = res.data.country_list;
                        this.blood_group_list = res.data.blood_group_list;
                        this.bank_list = res.data.bank_list;
                        this.designation_list = res.data.designation_list;
                        this.employee_type_list = res.data.employee_type_list;
                        this.department_list = res.data.department_list;
                        this.language_list = res.data.language_list;
                        this.emp_dob_doj = res.data.emp_dob_doj;
                        this.emp_contact_address_lock = res.data.emp_contact_address_lock;
                        this.emp_account_lock = res.data.emp_account_lock;

                        this.marital_status_list = res.data.marital_status_list;
                        this.payment_section_list = res.data.payment_section_list;
                        this.shift_list = res.data.shift_list;
                        this.employee_details_can_not_edit = res.data.employee_details_can_not_edit;

                        this.sub_crt_list = res.data.sub_crt_list;
                        this.main_sub_list = res.data.main_sub_list;
                        this.add_sub_list = res.data.add_sub_list;
                        this.service_type_list = res.data.service_type_list;
                        // let formatDate = moment(this.inst_data.date_of_birth).format(
                        //   "MMMM Do YYYY"
                        // );
                        // alert(formatDate)
                        // this.inst_data.date_of_birth_in_words = formatDate;
                        // this.critical_edit = res.data.critical_edit;
                    } else {
                        // alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Someting went wrong!!!");
                    window.console.log(error);
                    // alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    // this.comp_load = false;
                });
        },
        saveData() {
            this.dialog_upload = true;
            this.instructor_id = this.instid;
            const formData = {
                instid: this.instid,
                instrData: this.inst_data,
            };
            axios
                .post("/EmployeeProfile/saveEmployeePersonal", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Personal details updated successfully...");
                        }
                        this.dialog_upload = false;
                        // this.inst_data = res.data.inst_data;
                        // this.gender_list = res.data.gender_list;
                        // this.country_list = res.data.country_list;
                        // this.blood_group_list = res.data.blood_group_list;
                        // this.bank_list = res.data.bank_list;
                        // this.designation_list = res.data.designation_list;
                        // this.employee_type_list = res.data.employee_type_list;
                        // this.language_list = res.data.language_list;
                        // let formatDate = moment(this.inst_data.date_of_birth).format(
                        //   "MMMM Do YYYY"
                        // );
                        // // alert(formatDate)
                        // this.inst_data.date_of_birth_in_words = formatDate;
                        // // this.critical_edit = res.data.critical_edit;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Someting went wrong!!!");
                    // alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    // this.comp_load = false;
                });
        },

        copyAddress() {
            // alert("in copy add");
            this.copy_data = true;
            this.inst_data.permanent_address = this.inst_data.local_address;
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
